import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import Button from 'components/Buttons/Button';
import InternalForm from 'components/InternalForm';
// import StartupSearcher from 'components/StartupSearcher';
// import FundSearcher from 'components/FundSearcher';
import RequestAccess from 'components/RequestAccess';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTE_PATH } from 'routes';
import { ArrowLeft, DoorClosed } from 'lucide-react';
// import { WEBIEW_MESSAGE } from 'constants/webview';
// import { sendMessageToWebview } from 'utils/sendMessageToWebview';
import { ProgressBar } from 'xland-ui';
import RenderStartupInvite from './RenderStartupInvite';

export const FRONT_PAGE = 'frontPage';
// export const STARTUP_SEARCHER = 'startupSearcher';
// export const FUND_SEARCHER = 'fundSearcher';
export const FORM = 'form';
export const REQUEST_ACCESS = 'request_access';
export const MESSAGE_OWNER_EXIST = 'messageOwnerExist';
export const MESSAGE_REQUIRE_VALIDATION = 'requireValidation';
export const STARTUP_INVITE = 'startup_invite';

function OnboardingSteps(props) {
  const {
    id,
    literals,
    view,
    answers: oldAnswers,
    onSubmitForm,
    embed,
  } = props;

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const startupParam = searchParams.get('startup');
  const external = searchParams.get('external');

  let defaultRender = FORM;
  if (view === 'startup') {
    if (startupParam) {
      defaultRender = STARTUP_INVITE;
    }
  }

  if (id) {
    defaultRender = FORM;
  }

  // eslint-disable-next-line no-nested-ternary
  const [render, setRender] = useState(defaultRender);
  const [formNumSteps, setFormNumSteps] = useState(0);
  const [formStepNumber, setFormStepNumber] = useState(0);
  const [answers, setAnswers] = useState(oldAnswers);
  const [startup, setStartup] = useState();

  const FORM_STEP_QUESTIONS = 5;

  // const checkStartup = async () => {
  //   if (startup.id === 'other') {
  //     setAnswers({ ...answers, name: startup.name });
  //     setRender(FORM);
  //   } else {
  //     setRender(REQUEST_ACCESS);
  //   }
  // };

  const changeFormStep = (forward, stepAnswers) => {
    if (forward) {
      const newAnswers = { ...answers };
      Object.keys(stepAnswers).forEach((key) => {
        if (typeof stepAnswers[key] === 'object' && !(stepAnswers[key] instanceof Array)) {
          newAnswers[key] = { ...answers[key], ...stepAnswers[key] };
        } else {
          newAnswers[key] = stepAnswers[key];
        }
      });
      setAnswers(newAnswers);
      if (formStepNumber === (formNumSteps - 1)) {
        onSubmitForm(newAnswers, view);
      } else {
        setFormStepNumber(formStepNumber + 1);
      }
    } else {
      setFormStepNumber(formStepNumber - 1);
    }
  };

  const onLoadForm = (questions) => {
    setFormNumSteps(Math.ceil(questions.length / FORM_STEP_QUESTIONS));
  };

  const renderFormStep = () => {
    const buttons = [];
    buttons.push({
      key: 'back',
      text: literals.previous,
      color: 'secondary',
      onClick: !formStepNumber
        ? () => navigate(`${ROUTE_PATH.ONBOARDING}?type=${view}`)
        : (ev) => { ev.preventDefault(); changeFormStep(false); },
    });
    buttons.push({
      key: 'submit',
      type: 'submit',
      text: formStepNumber === (formNumSteps - 1) ? literals.start : literals.next,
      onClick: a => changeFormStep(true, a),
    });

    return (
      <>
        { formNumSteps && (
          <ProgressBar
            step={formStepNumber + 1}
            totalSteps={formNumSteps}
            className='mb-4'
          />
        )}
        <InternalForm
          type={view}
          answers={answers}
          page={formStepNumber}
          size={FORM_STEP_QUESTIONS}
          buttons={buttons}
          onLoad={onLoadForm}
        />
      </>
    );
  };

  return (
    <div className={`onBoarding ${render === FRONT_PAGE ? 'firstStep' : ''}`}>
      {!embed && (
        <div className='onboarding-header'>
          <Link to={ROUTE_PATH.ONBOARDING} className='closeOnboarding'>
            <ArrowLeft />
          </Link>
          <Link to={ROUTE_PATH.LOGOUT} className='onboarding-header--logout'>
            <span>{literals.logout}</span>
            <DoorClosed size={20} />
          </Link>
        </div>
      )}

      <div className='onboarding-wrapper'>

        <div className='onboarding-next-step'>
          {!embed && (
            <div className='onboarding-step'>
              <h1 className='h2'>{literals[`${view}Data`]}</h1>
              {/* <h3 className='h4'>{literals.subtitle}</h3> */}
            </div>
          )}
          <div className='onboarding-form-wrapper'>
            {render === FORM && renderFormStep()}
            {render === STARTUP_INVITE && (
              <RenderStartupInvite
                literals={literals}
                id={startupParam}
                render={render}
                setRender={setRender}
                startup={startup}
                setStartup={setStartup}
                external={external === '1'}
              />
            )}
            {[REQUEST_ACCESS, MESSAGE_OWNER_EXIST, MESSAGE_REQUIRE_VALIDATION].includes(render) && (
              <RequestAccess
                startup={startup}
                render={render}
                setRender={setRender}
                embed={embed}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

OnboardingSteps.propTypes = {
  id: PropTypes.string.isRequired,
  literals: PropTypes.object.isRequired,
  view: PropTypes.string.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  answers: PropTypes.object,
  embed: PropTypes.bool,
};

OnboardingSteps.defaultProps = {
  answers: null,
  embed: false,
};

export default OnboardingSteps;
